<div class="toolbox row justify-content-between">

  <div class="actions col-is-auto">
    <a [routerLink]="['/pages', 'generator']">
      <img src="assets/logo_d.png" alt="Deebr" style="height: 30px;">
    </a>

    <button nbButton appearance="outline" (click)="onBackOrCloseHistory()">
      <i class="bi-arrow-left"></i>
    </button>

    @if (showToolbox) {
    <input type="text" nbInput fullWidth [(ngModel)]="emailName" (ngModelChange)="onEmailNameChange($event)" nbInput
      placeholder="Nom de l'email" style="width: 300px;" />
    }
    @if (showToolbox && dynamicHtml && !email?.campaign_id) {
    <button nbButton size="small" (click)="openDynamicChoiceDialog()" [disabled]="!hasDynamicBlock || !email?.template_id" class="btn-dynamic"
      [class.btn-dynamic-active]="hasDynamicBlock && !!email?.template_id" style="margin-left: 10px;"
      nbTooltip="{{ !email?.template_id ? 'Personnalisation disponible uniquement sur les emails générés depuis un template Deebr' : (hasDynamicBlock ? 'Lancer la personnalisation IA' : 'Activez la personnalisation sur un bloc pour continuer') }}">
      🪄 Personnalisation IA
    </button>
    }
    @if (showToolbox) {
    <button *ngIf="email?.campaign_id" nbButton status="info" size="small" (click)="openDynamicManagement()"
      style="margin-left:auto">
      <nb-icon icon="image-outline"></nb-icon> Gérer les blocs dynamiques
    </button>
    <span *ngIf="email?.campaign_id && email?.firestore_status === 'pending'" class="firestore-status pending"
      nbTooltip="La personnalisation est en cours de chargement. L'email ne peut pas encore être envoyé.">
      <nb-icon icon="loader-outline"></nb-icon> Mise en cache en cours...
    </span>
    <span *ngIf="email?.campaign_id && email?.firestore_status === 'ready'" class="firestore-status ready"
      nbTooltip="La personnalisation est prête. L'email peut être envoyé.">
      <nb-icon icon="checkmark-circle-2-outline"></nb-icon> Prêt à envoyer
    </span>
    }
  </div>
  @if (showToolbox) {
  <div class="actions col-is-auto">
    <button id="undoButton" nbButton appearance="outline"><i class="bi-arrow-counterclockwise"></i></button>
    <!-- Le même bouton avec ID attendu par Stripo -->
    <button (click)="openHistory()" nbButton appearance="outline"> <i class="bi-clock-history"></i>
    </button>
    <button id="redoButton" nbButton appearance="outline"><i class="bi-arrow-clockwise"></i></button>
  </div>
  }
  @if (showToolbox) {
  <div class="actions col-is-auto">
    <div ngbDropdown class="d-inline-block">
      <button nbButton appearance="outline" ngbDropdownToggle>
        <i class="bi bi-share"></i>
      </button>
      <div ngbDropdownMenu>
        <form class="px-4 py-3">
          <div class="mb-3">
            <label for="previewLink">Lien de Prévisualisation</label>
            <div class="input-group">
              <input type="text" id="previewLink" class="form-control" readonly [value]="previewHtmlUrl">
              <button class="btn btn-outline-secondary" type="button"
                (click)="previewHtmlUrl && copyToClipboard(previewHtmlUrl)">
                Copier
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <button (click)="openExternalPreview()" [disabled]="loadingPreview" [nbSpinner]="loadingPreview" nbButton
      appearance="outline">
      <i class="bi-tablet"></i>
    </button>
    <div ngbDropdown class="d-inline-block">
      <button nbButton appearance="outline" ngbDropdownToggle>
        <i class="bi-send"></i>
      </button>

      <div ngbDropdownMenu>
        <form class="px-4 py-3">
          <div class="mb-3">
            <label for="previewLink">Envoyer un email test : </label>

            <div class="input-group">
              <input type="text" id="previewLink" class="form-control" [(ngModel)]="batEmails" name="batEmailsInput" />
              <button class="btn btn-outline-secondary" type="button" [disabled]="loadingBat" [nbSpinner]="loadingBat"
                (click)="sendBat()">
                Envoyer
              </button>
            </div>

            <!-- 👉 LIGNE D’AIDE AJOUTÉE, RIEN D’AUTRE NE CHANGE -->
            <small class="text-muted">
              Vous pouvez ajouter plusieurs adresses, séparées par des virgules.
            </small>

          </div>
        </form>
      </div>
    </div>

    <button (click)="exportSocialMedia()" nbButton appearance="outline" [nbSpinner]="loading" [disabled]="loading"
      [nbTooltip]="'Export Batch Facebook Instagram'">
      <nb-icon icon="message-square-outline" pack="eva"></nb-icon>
    </button>
    <button id="codeEditor" nbButton appearance="outline" status="danger"><i class="bi-code-slash"></i></button>
    <button nbButton appearance="outline" status="danger" (click)="export()" [disabled]="isExporting"
      [nbSpinner]="isExporting" nbSpinnerStatus="danger">
      Exporter
    </button>
    <button nbButton [disabled]="isManualSave" [nbSpinner]="isManualSave" appearance="filled" status="danger"
      (click)="save(true)">Enregistrer</button>
  </div>
  }
  <div class="mobiledesktopview col-is-auto">
    <button nbButton nbButtonToggle [pressed]="selectedView === 'desktop'" (click)="onSelectView('desktop')"
      id="desktop" class="toggle-button" [title]="showToolbox ? 'Vue Desktop' : 'Voir Desktop dans Stripo'">
      <i class="bi bi-display"></i>
    </button>

    <button nbButton nbButtonToggle [pressed]="selectedView === 'mobile'" (click)="onSelectView('mobile')" id="mobile"
      class="toggle-button" [title]="showToolbox ? 'Vue Mobile' : 'Voir Mobile dans Stripo'">
      <i class="bi bi-phone"></i>
    </button>

    <div ngbDropdown>
      <button nbButton appearance="outline" ngbDropdownToggle>

      </button>
      <div ngbDropdownMenu class="mobiledesktopdropdow">
        <div class="custom-toggle">
          <nb-toggle [checked]="areHiddenElementsHidden" (checkedChange)="onManualToggle($event)" status="info"
            style="margin-left:10px">
            Afficher les éléments masqués
          </nb-toggle>
        </div>

      </div>
    </div>


  </div>

</div>


<div class="notification-zone"></div>
<div class="container">
  <div class="loading-spinner" [class.hidden]="!isLoading">
    <div class="spinner"></div>
  </div>
  <div class="editor" [class.hidden]="isLoading">
    <div id="stripoEditorContainer" class="full-height"></div>
  </div>

</div>


<script src="https://code.jquery.com/jquery-3.6.0.min.js"
  integrity="sha256-/xUj+3OJU5yEx1q6GSYGSHk7tPXikynS7ogEvDej/m4=" crossorigin="anonymous"></script>

@if (showPopup) {
<app-email-preview-popup [emailId]="initialEmailId" [isDynamic]="!!email?.campaign_id"></app-email-preview-popup>
}


<ng-template #dialogErrorExport let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body class="text-center">Une erreur s'est produite lors de l'export batch. <br>Nous vous invitons à vous
      rapprocher de votre contact Deebr si l'erreur se reproduit</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="danger" (click)="closeDialog()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogErrorAnimate let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body>{{errorMessage}}</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="danger" (click)="closeDialog()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>



<ng-template #dialogPushEmail let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body class="text-center">{{ data.message }}</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="success" (click)="ref.close()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogErrorPushEmail let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body class="text-center">Une erreur s'est produite lors de l'envoi de votre email<br>Nous vous invitons à
      vous rapprocher de votre contact Deebr si l'erreur se reproduit</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="danger" (click)="ref.close()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogErrorWriteOnImage let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body class="text-center">Une erreur s'est produite lors du chargement des images<br>Nous vous invitons à
      vous rapprocher de votre contact Deebr si l'erreur se reproduit</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="danger" (click)="closeDialog()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogDynamicChoice let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Email dynamique</nb-card-header>
    <nb-card-body>S'agit-il d'un email automation marketing ou d'une campagne one shot ?</nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="info" size="small" (click)="onDynamicTypeSelected(ref, true)">Automation
            Marketing</button>
        </div>
        <div class="col text-center">
          <button nbButton status="info" size="small" (click)="onDynamicTypeSelected(ref, false)">Campagne One
            Shot</button>
        </div>
        <div class="col text-center">
          <button nbButton status="danger" size="small" (click)="ref.close()">Annuler</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogDynamicConfirm let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Confirmation</nb-card-header>
    <nb-card-body>
      <div *ngIf="hasExistingDynamicCopy" style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px; margin-bottom: 12px;">
        <strong>Attention :</strong> Une version personnalisée existe déjà pour cet email. Elle sera <strong>écrasée</strong>.
      </div>
      Êtes-vous sûr de vouloir lancer la dynamisation ?<br><br>
      Cette opération peut prendre plusieurs minutes, vous serez averti par mail lorsque la tâche sera effectuée.
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="success" (click)="confirmDynamic(ref)">Confirmer</button>
        </div>
        <div class="col text-center">
          <button nbButton status="danger" (click)="ref.close()">Annuler</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #dialogDynamicConflict let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Personnalisation en cours</nb-card-header>
    <nb-card-body>
      <div style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px; margin-bottom: 12px;">
        <strong>Attention :</strong> Une personnalisation est actuellement en cours pour
        <strong>"{{ conflictEmailName }}"</strong>.
      </div>
      Voulez-vous arrêter la personnalisation en cours et en lancer une nouvelle ?
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="warning" (click)="forcePersonalization(ref)">Remplacer</button>
        </div>
        <div class="col text-center">
          <button nbButton status="basic" (click)="ref.close()">Annuler</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>